import { normalizeAskGuruQuery } from './askBhriguQueryNormalize';

/**
 * @param {string} a
 * @param {string} b
 */
function tokenSimilarity(a, b) {
  const ta = new Set(String(a || '').split(/\s+/).filter((t) => t.length >= 2));
  const tb = new Set(String(b || '').split(/\s+/).filter((t) => t.length >= 2));
  if (!ta.size || !tb.size) return 0;
  let inter = 0;
  for (const t of ta) {
    if (tb.has(t)) inter += 1;
  }
  return inter / (ta.size + tb.size - inter);
}

/**
 * Merge recent feed rows by semantic meaning (content tokens), summing ask_count.
 * @param {Array<Record<string, unknown>>} rows
 * @returns {Array<Record<string, unknown> & { ask_count: number }>}
 */
export function groupBhriguRecentFeed(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return [];

  /** @type {Array<Record<string, unknown> & { ask_count: number; semanticKey: string }>} */
  const groups = [];

  for (const row of rows) {
    const questionText = String(row.question_text || '').trim();
    if (!questionText) continue;

    const semanticKey = normalizeAskGuruQuery(questionText).normalizedQuery || questionText.toLowerCase();
    const rowCount = Math.max(1, Number(row.ask_count) || 1);

    const existing = groups.find((g) => {
      if (g.semanticKey === semanticKey) return true;
      return tokenSimilarity(g.semanticKey, semanticKey) >= 0.85;
    });

    if (existing) {
      existing.ask_count += rowCount;
      if (row.answer_text && !existing.answer_text) {
        existing.answer_text = row.answer_text;
        existing.id = row.id;
      }
      const rowDate = new Date(String(row.created_at || 0)).getTime();
      const existingDate = new Date(String(existing.created_at || 0)).getTime();
      if (rowDate > existingDate) {
        existing.created_at = row.created_at;
        existing.question_text = questionText;
        if (row.id) existing.id = row.id;
      }
      if (row.is_mine) existing.is_mine = true;
      continue;
    }

    groups.push({
      ...row,
      question_text: questionText,
      semanticKey,
      ask_count: rowCount,
    });
  }

  return groups
    .sort((a, b) => new Date(String(b.created_at || 0)).getTime() - new Date(String(a.created_at || 0)).getTime())
    .map(({ semanticKey, ...rest }) => rest);
}
